import { useEffect } from 'react';
import { useQuery } from 'react-query';
import * as R from 'ramda';

import { useNotifications } from 'reapop';

import { withErrorBoundary } from '$app/modules/common/ErrorBoundary';
import EventsPage from '../components/EventsPage';

const EventsPageContainer = () => {
  const { notify } = useNotifications();

  const { data, error, isFetching } = useQuery(`/content/careerfair-events`);

  useEffect(() => {
    if (error)
      notify({
        message: 'Could not load events. Please refresh the page.',
        status: 'error',
      });
  }, [error, notify]);

  return <EventsPage isFetching={isFetching} data={data?.body?.list} />;
};

export default R.compose(withErrorBoundary)(EventsPageContainer);
